import {ProductGenderPriceComponent} from './product-gender-price-component';
import {AudienceType} from './audience-type';

export class GenderPrice {
  id: number;
  genderPriceType: number;
  audienceType: number;
  audienceTypeDescription: string;
  audienceTypeLabel: string;
  value: number;
  currency: string;
  isExcludedFromBilling: boolean;
  isTaxIncludedInPrice: boolean;
  vatType: number;
  netprice: number;
  grossprice: number;
  quantityToBook: number;
  audienceTypeOccupancy: number;
  audienceDescription: string;
  productGenderPriceComponents: ProductGenderPriceComponent[];
  maxAvailabilityForCurrentAudienceType: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/api/model/gender-price.ts